
import Vue from "vue";

export default Vue.extend({
  name: "menu-item",
  props: {
    menuId: Number,
    iconName: { type: String, required: false },
    title: { type: String, required: true, default: "" },
    badge: { type: Number, required: false, default: -1 },
    highlight: { type: Boolean, required: false, default: false },
    imgSrc: { type: String, required: false },
    grayOut: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
  },
  methods: {
    itemClicked(menuId: number) {
      if (!this.disabled) this.$emit("item-clicked", Number(menuId));
    },
  },
});
